import { FC } from 'react';

import ROUTES from '@agency/routes/routes.constant';
import { t } from '@core/i18n';
import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Badge, BadgeSize, BadgeTheme } from '@shared/components/badge-new';
import { Link } from '@shared/components/link';
import { ZapIcon } from '@shared/icons/zap';

import { styles } from './SideNavigationExploreUpsellItem.styles';

export type SideNavigationExploreUpsellItemProps = WithStyles<typeof styles>;

const SideNavigationExploreUpsellItemComponent: FC<SideNavigationExploreUpsellItemProps> = ({ classes }) => {
  return (
    <Link classes={{ root: classes.root }} to={`${ROUTES.upgradeToPro.root}`}>
      <span className={classes.title}>{t('upgrade_to_pro_1')}</span>
      <Badge
        classes={{ badge: classes.badge }}
        content={t('explore').toUpperCase()}
        size={BadgeSize.small}
        startIcon={<ZapIcon classes={{ root: classes.icon }} />}
        theme={BadgeTheme.app}
      />
    </Link>
  );
};

export const SideNavigationExploreUpsellItem = withStyles(styles)(SideNavigationExploreUpsellItemComponent);
